
import { BalanceDto } from '@core/mappers/user/pushNotifications/dtos/BalanceDto';
import Balance from '@core/models/user/pushNotifications/Balance';

export function transformBalance(obj: BalanceDto): Balance {
    const balance: Balance = {
        comitted: obj.BalanceSummary.committed,
        total: obj.BalanceSummary.total,
        uncommitted: obj.BalanceSummary.uncommitted,
        withdrawable: obj.BalanceSummary.withdrawable,
    };
    return balance;
}
